import { render, staticRenderFns } from "./view-plans.vue?vue&type=template&id=306fe56a&scoped=true"
import script from "./view-plans.vue?vue&type=script&setup=true&lang=js"
export * from "./view-plans.vue?vue&type=script&setup=true&lang=js"
import style0 from "./view-plans.vue?vue&type=style&index=0&id=306fe56a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306fe56a",
  null
  
)

export default component.exports